import { http } from '@/utils/http';
import qs from 'qs';

export const getBaseInfo = (id: string) => {
  return http.get(
    `/vote/2020project/2020custom_voting/controller.php?enews=base-info&voteId=${id}`,
  );
};

export const getList = (id: string) => {
  return http.get(
    `/vote/2020project/2020custom_voting/controller.php?enews=vote-list&voteId=${id}`,
  );
};

export const vote = (id: string, data: any) => {
  return http.post(
    `/vote/2020project/2020custom_voting/controller.php?enews=vote&voteId=${id}`,
    qs.stringify(data),
  );
};
